<template>
  <div class="client-manager">
    <div class="search-client">
      <div>
        <label title="用户昵称" class="info">用户昵称</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="支持模糊匹配" v-model="searchNickname" @pressEnter="search"/>
        <label title="微信号" class="info">微信号</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="仅支持全匹配" v-model="searchUsername" @pressEnter="search"/>
        <label title="手机号" class="info">手机号</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="仅支持全匹配" v-model="searchPhone" @pressEnter="search"/>
        <a-button type="primary" @click="search">搜索</a-button>
        <a-button type="primary" @click="clear">清空</a-button>
        <div style="margin-left: -100px">
            <a-button type="primary" @click="outputExcel(1)" style="margin:10px 10px 0 100px;">导出一周</a-button>
            <a-button type="primary" @click="outputExcel" style="margin:10px 10px 0 0;">导出</a-button>
            <a-popover title="二维码">
              <template slot="content">
                <img :src="wechatCode" style="width: 200px; height: 200px;"/>
              </template>
              <a-button type="primary" @mouseenter="getCode">协议登录</a-button>
            </a-popover>
        </div>
      </div>
    
      <div style="margin-top: 15px;">
        <label title="手机号" class="info">未收到验证码的手机号</label><a-input style="max-width: 10%; margin-right: 20px" v-model="failedPhone" @pressEnter="search"/>
        <a-button type="primary" @click="getSms">获取验证码</a-button>
      </div>
    </div>
    <a-table :columns="columns"
             :dataSource="data"
             :loading="loading"
             :pagination="pagination"
             @change="handleTableChange"
             class="client-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <!-- 用户 -->
      <div class="avatar-36-con" slot="base_info" slot-scope="text">
        <img class="avatar" :src="text.avatar_url"/>
        <div class="nickname">{{text.nickname + (text.username ? '（' + text.username + '）' : '')}}</div>
        <a-icon v-if="text.sex === 1" type="man" style="color: #1890ff"></a-icon>
        <a-icon v-if="text.sex === 2" type="woman" style="color: #ff4d4f"></a-icon>
      </div>
      <!-- 地区 -->
      <div slot="location" slot-scope="text">
        {{text.province + (text.city ? ' ' + text.city : '')}}
      </div>
      <!-- VIP -->
      <div slot="vip" slot-scope="text">
        <span v-if="text === 0"> {{ VIP_LEVEL[text] }} </span>
        <span v-if="text === 1" style="color: #1890ff"> {{ VIP_LEVEL[text] }} </span>
        <span v-if="text === 2" style="color: #ff4d4f"> {{ VIP_LEVEL[text] }} </span>
      </div>
      <!-- APP -->
      <div slot="app" slot-scope="text">
        {{ APP_NAME[text] }}
      </div>
      <!-- phone -->
      <div slot="phone" slot-scope="text">
        {{ text ? text: '-' }}
      </div>
      <!-- chatroom_num -->
      <div slot="chatroom_num" slot-scope="text, record">
        <EditableCellChatroomNum v-if="record.vip === 2" :chatroom_used="text.chatroom_used" :chatroom_count="text.chatroom_count" :client_id="record.client_id"></EditableCellChatroomNum>
        <div v-else>
          {{ text.chatroom_used + '/' + text.chatroom_count }}
        </div>
      </div>
      <!-- bot_list -->
      <div slot="bot_list" slot-scope="text, record">
        {{text.botNum}}
        <robot-list :text="text.botList" :clientId="record.client_id" :allBotList="allBotList"  @refresh="refresh" />
        <!-- <bot-change v-show="showTransfer" /> -->
        
      </div>
      <!-- actions -->
      <div slot="actions" slot-scope="text, record">
        <a-dropdown >
          <a-menu slot="overlay" @click="handleMenuClick($event, record)">
            <a-menu-item>
              <ClientDetail :record="record"></ClientDetail>
            </a-menu-item>
            <a-menu-item v-if="record.vip !== 2" key='set_vip_2'>设置企业用户</a-menu-item>
            <a-menu-item v-if="record.vip === 2" key='cancel_vip_2'>取消企业用户</a-menu-item>
            <a-menu-item :disabled="record.probation === 1" key='reset_free_chatroom'>重置免费一个群</a-menu-item>
            <a-menu-item key="chatroom_live_bot">
              <chatroom-live-bot :client-id="record.client_id" :nickname="record.nickname"></chatroom-live-bot>
            </a-menu-item>
            <a-menu-item key='add_bot'>
              <BotSelect :dataIndex="record.client_id" :allBotList="allBotList" v-on:on-seleted="botSelected"></BotSelect>
            </a-menu-item>
            <a-menu-item key='backup_bots' v-if="record.vip === 2">
              <backup-bots :client-id="record.client_id" :bot-list="record.bot_list"></backup-bots>
            </a-menu-item>
            <!--<a-menu-item key='jump_to'>登录后台</a-menu-item>-->
            <a-menu-item v-if="balanceEditable" key='edit_balance'>
              <EditBalance :dataIndex="record.client_id" :record="record" v-on:on-balance-edit="onBalanceEdit" :priceList="priceList"></EditBalance>
            </a-menu-item>
            <a-menu-item key='edit_client_batch_send_max_count'>
              <EditClientBatchSendMaxCount :record="record" v-on:on-finish="onFinish"></EditClientBatchSendMaxCount>
            </a-menu-item>
            <a-menu-item key='edit_client_everyday_batch_send_max_count'>
              <EditClientEverydayBatchSendMaxCount :record="record" v-on:on-finish="onFinish1"></EditClientEverydayBatchSendMaxCount>
            </a-menu-item>
            <a-menu-item key='chattings'>
              <ChattingModal :dataIndex="record.username" :is_to_friend="true" :bot_list="record.bot_list"/>
            </a-menu-item>
            <a-menu-item key='jump'>跳转到用户后台</a-menu-item>
            <a-menu-item key='change_tel'>
              <change-tel :old-phone="parseInt(record.phone)"></change-tel>
            </a-menu-item>
            <a-menu-item key='get_agent_excel'>导出分销记录</a-menu-item>
            <a-menu-item key='get_price_check_excel'>导出报价核对</a-menu-item>
            <a-menu-item key="get_child_chatroom">导出子账号群列表</a-menu-item>
            <a-menu-item key="change_disable_ad">{{record.disable_ad === 1 ? '显示活码底部文案' : '隐藏活码底部文案'}}</a-menu-item>
            <a-menu-item>
                <HeartbeatNetworkStatus :record="record" ></HeartbeatNetworkStatus>
            </a-menu-item>
          </a-menu>
          <a-button>
            操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
    </a-table>
  </div>
</template>

<script>
// import AIcon from 'ant-design-vue/es/icon/icon'
import AButton from 'ant-design-vue/es/button/button'
import EditableCellChatroomNum from './EditableCellChatroomNum'
import ClientDetail from './ClientDetail'
import EditClientBatchSendMaxCount from './EditClientBatchSendMaxCount'
import EditClientEverydayBatchSendMaxCount from './EditClientEverydayBatchSendMaxCount'
import EditBalance from './EditBalance'
import BotSelect from './BotSelect'
import AModal from 'ant-design-vue/es/modal/Modal'
import ChattingModal from './ChattingModal'
import BackupBots from './BackupBots'
import ChatroomLiveBot from './ChatroomLiveBot'
import ChangeTel from './ChangeTel'
import HeartbeatNetworkStatus from './HeartbeatNetworkStatus.vue'
import RobotList from './RobotList.vue'
import BotChange from './BotChange.vue'

const axios = require('axios')
export default {
  name: 'ClientManage',
  components: {
    ChangeTel,
    ChatroomLiveBot,
    BackupBots,
    AModal, AButton, EditableCellChatroomNum, BotSelect, ClientDetail, EditBalance, EditClientBatchSendMaxCount, EditClientEverydayBatchSendMaxCount, ChattingModal,
    HeartbeatNetworkStatus, RobotList, BotChange },
  data () {
    return {
      failedPhone: undefined,
      balanceEditable: false,
      searchNickname: '',
      searchPhone: '',
      searchUsername: '',
      VIP_LEVEL: {
        0: '普通用户',
        1: 'VIP 用户',
        2: '企业用户'
      },
      APP_NAME: {
        zidou: '紫豆助手',
        yaca: '友问币答',
        test: '测试环境'
      },
      getPhoneSmsCodeUrl: global.DOMAIN + 'UClient/get_phone_sms_code',
      changeDisableAdUrl: global.DOMAIN + 'UClient/change_disable_ad',
      wechatLoginUrl: global.DOMAIN + 'UClient/wechat_login',
      getClientListUrlPostFix: 'UClient/get_client_list',
      getClientListExcelUrlPostFix: 'UClient/get_client_list_excel',
      getPriceCheckExcelUrlPostFix: 'UClient/get_price_check_excel',
      getChildChatroomUrlPostFix: 'UClient/get_children_chatroom_count_excel',
      getBotListUrlPostFix: 'UBot/get_bot_list',
      getBalanceEditablePostFix: 'UBalance/get_balance_editable',
      getPriceListPostFix: 'UBalance/get_price_list',
      setVipUrlPostFix: 'UClient/set_vip',
      batchAddBotUrlPostFix: 'UBot/batch_add_bot',
      unbindBotUrlPostFix: 'UBot/unbind_bot',
      resetFreeChatroomUrlPostFix: 'UClient/reset_free_chatroom',
      pagination: {
        // hideOnSinglePage: true,
        showTotal: total => `共 ${total} 个客户`,
        pageSize: 10,
        current: 1
      },
      data: [],
      loading: false,
      columns: [{
        title: '基础信息',
        dataIndex: 'base_info',
        scopedSlots: { customRender: 'base_info' }
      }, {
        title: '地区',
        dataIndex: 'location',
        scopedSlots: { customRender: 'location' }
      }, {
        title: '类型',
        dataIndex: 'vip',
        align: 'center',
        scopedSlots: { customRender: 'vip' },
        filters: [{
          text: '普通用户',
          value: '0'
        }, {
          text: 'VIP 用户',
          value: '1'
        }, {
          text: '企业用户',
          value: '2'
        }]
      }, {
        title: 'APP',
        dataIndex: 'app',
        scopedSlots: { customRender: 'app' },
        filters: [{
          text: '紫豆助手',
          value: 'zidou'
        }, {
          text: '友问币答',
          value: 'yaca'
        }]
      }, {
        title: '手机号',
        dataIndex: 'phone',
        scopedSlots: { customRender: 'phone' }
      }, {
        title: '机器人',
        dataIndex: 'bot_list',
        scopedSlots: { customRender: 'bot_list' },
        // filters: []
      }, {
        title: '已用/可用群',
        dataIndex: 'chatroom_num',
        align: 'center',
        width: '150px',
        scopedSlots: { customRender: 'chatroom_num' },
        sorter: true
      }, {
        title: '当前积分',
        dataIndex: 'balance',
        sorter: true
      }, {
        title: '创建时间',
        dataIndex: 'create_time'
      }, {
        title: '操作',
        dataIndex: 'actions',
        scopedSlots: { customRender: 'actions' }
      }],
      vipList: [],
      appList: [],
      orderBy: {},
      botList: [],
      allBotList: [],
      priceList: {},
      wechatCode: undefined,
      visibleOfRobotList: false
    }
  },
  computed: {
    params: function () {
      // console.log('filter', this.filters)
      return {
        // results: this.pagination.pageSize,
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
        nickname: this.searchNickname,
        phone: this.searchPhone,
        username: this.searchUsername,
        vip_list: this.vipList,
        app_list: this.appList,
        order_by: this.orderBy,
        bot_username_list: this.botList
        // chatroom_nickname: this.searchChatroomNickname,
        // owner_nickname: this.searchOwnerNickname,
        // level: (this.filters.level || []).map(item => parseInt(item)),
        // group: (this.filters.group || []).map(item => parseInt(item)),
        // order_by: this.order_by
      }
    },
    getClientListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getClientListUrlPostFix
    },
    getBotListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBotListUrlPostFix
    },
    getBalanceEditableUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBalanceEditablePostFix
    },
    getPriceListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getPriceListPostFix
    },
    setVipUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.setVipUrlPostFix
    },
    batchAddBotUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.batchAddBotUrlPostFix
    },
    unbindBotUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.unbindBotUrlPostFix
    },
    resetFreeChatroomUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.resetFreeChatroomUrlPostFix
    },
  },
  created () {
    this.fetchBotList()
    this.fetchPriceList()
    this.fetchBalanceEditable()
    this.fetch()
  },
  provide () {
    return {
      getAllBotList: this.getAllBotList
    }
  },
  methods: {
    refresh(params) {
      this.fetchBotList()
      this.fetchPriceList()
      this.fetchBalanceEditable()
      this.fetch()
      
    },
    getAllBotList() {
      // console.log("this data: ", this.data)
      return this.allBotList
    },
    handleTableChange (pagination, filters, sorter) {
      // console.log('handleTableChange')
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      // console.log('sorter', sorter)
      const { columnKey, order } = sorter
      var orderKey = columnKey
      this.orderBy = {}
      if (columnKey === 'chatroom_num') {
        orderKey = 'chatroom_used'
      }
      if (columnKey !== undefined) {
        this.orderBy[orderKey] = 'asc'
        if (order === 'descend') {
          this.orderBy[orderKey] = 'desc'
        }
        // console.log('sorter', sorter, columnKey, order)
      }
      // console.log('filters', filters)
      this.vipList = (filters['vip'] || []).map(item => parseInt(item))
      this.appList = filters['app'] || []
      // this.botList = filters['bot_list'] || []
      // this.filters = filters
      this.fetch()
    },
    fetchBotList () {
      axios.post(this.getBotListUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.allBotList = data.data.content.bot_list
            // this.columns[5].filters = []
            // this.allBotList.forEach((item) => {
              // this.columns[5].filters.push({
              //   text: item.nickname,
              //   value: item.username
              // })
            // })
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    fetchBalanceEditable () {
      axios.post(this.getBalanceEditableUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          this.balanceEditable = data.data.content.balance_editable
          if (data.data.err_code === 0) {
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    fetchPriceList () {
      axios.post(this.getPriceListUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.priceList = data.data.content.price_list
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    search () {
      this.pagination.current = 1
      this.fetch()
    },
    clear () {
      this.searchUsername = ''
      this.searchNickname = ''
      this.searchPhone = ''
      this.search()
    },
    fetch () {
      // console.log('fetch')
      console.log('params:', this.params)
      this.loading = true
      axios.post(this.getClientListUrl, {
        token: sessionStorage.token,
        ...this.params
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log("get client list: ", data.data)
            const pagination = { ...this.pagination }
            pagination.total = data.data.content.total_count
            let clientList = data.data.content.client_list
            let dataList = []
            clientList.forEach((item) => {
              let baseInfo = {
                sex: item.sex,
                avatar_url: item.avatar_url,
                nickname: item.nickname || '',
                username: item.username
              }
              let location = {
                country: item.country || '',
                city: item.city || '',
                province: item.province || ''
              }
              let chatroomNum = {
                chatroom_used: item.chatroom_used,
                chatroom_count: item.chatroom_count
              }
              let botInfo = {
                botList: item.bot_list,
                botNum: item.bot_list.length
              }
              let createTime = item.create_time
              // let chatroomname = chatroomInfo.chatroomname
              // let memberCount = chatroomInfo.member_count
              // let chatroomNickname = chatroomInfo.nickname || chatroomInfo.nickname_default || ''
              // let chatroomAvatarUrl = chatroomInfo.avatar_url
              // let clientNickname = clientInfo.nickname
              // let clientAvatarUrl = clientInfo.avatar_url
              // let clientUsername = clientInfo.username
              // let tagList = chatroomTag.tag_list || []
              dataList.push({
                base_info: baseInfo,
                location: location,
                chatroom_num: chatroomNum,
                ...item,
                bot_list: botInfo,
                create_time: this.transform(createTime, 'yyyy-MM-dd hh:mm:ss')
              })
            })
            this.loading = false
            // console.log('dataList', dataList)
            this.data = dataList
            this.pagination = pagination
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
      console.log("this data", this.data)
    },
    outputExcel (week = 0) {
      // console.log('outputExcel', this.getChatroomListExcelUrl)
      let baseUrl = global.DOMAIN + global.API_VERSION + this.getClientListExcelUrlPostFix + '?'
      for (let key in this.params) {
        const value = this.params[key]
        if (key === 'order_by') {
          for (let orderKey in value) {
            baseUrl += key + '=' + orderKey + ' ' + value[orderKey] + '&'
            break
          }
          continue
        }
        baseUrl += key + '=' + value + '&'
      }
      baseUrl += 'token' + '=' + sessionStorage.token
      if (week === 1) {
        baseUrl += '&week_flag=1'
      }
      console.log(baseUrl)
      window.open(baseUrl, '_blank')
    },
    transform (value, fmt, ...args) {
      if (typeof value === 'number') {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11) value *= 1000

        let date = new Date(value)
        var o = {
          'M+': date.getMonth() + 1, // 月份
          'd+': date.getDate(), // 日
          'h+': date.getHours(), // 小时
          'm+': date.getMinutes(), // 分
          's+': date.getSeconds(), // 秒
          'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay()
        }
        var weekMap = [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ]
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt) && k !== 'W') {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
          }
          if (new RegExp('(' + k + ')').test(fmt) && k === 'W') {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]])
          }
        }
        return fmt
      } else return ''
    },
    handleMenuClick (e, record) {
      let clientId = record.client_id
      let action = e.key
      if (action === 'set_vip_2') {
        this.setVip(clientId, 2)
      } else if (action === 'cancel_vip_2') {
        this.setVip(clientId, 1)
      } else if (action === 'add_bot') {
        this.addBot()
      } else if (action === 'reset_free_chatroom') {
        this.resetFreeChatroom(clientId)
      } else if (action === 'edit_balance') {
        this.editBalance()
      } else if (action === 'jump') {
        var url = process.env.VUE_APP_TO_ZIDOU_URL
        url += 'features?token=' + record.token
        console.log(url)
        window.open(url)
      } else if (action === 'get_agent_excel') {
        var url = ''
        if (record.app === 'zidou' || 'yaca') {
          url = 'https://api.zidouad.com/'
        }
        url += 'search/get_agent_excel?token=psw_getagent&open_id=' + record.open_id
        console.log(url)
        window.open(url)
      } else if (action === 'get_price_check_excel') {
        // console.log('outputExcel', this.getChatroomListExcelUrl)
        let baseUrl = global.DOMAIN + global.API_VERSION + this.getPriceCheckExcelUrlPostFix + '?'
        baseUrl += 'token' + '=' + sessionStorage.token
        baseUrl += '&' + 'client_id' + '=' + clientId
        console.log('outputExcel', baseUrl)
        window.open(baseUrl, '_blank')
      } else if (action === 'get_child_chatroom') {
        let baseUrl = global.DOMAIN + global.API_VERSION + this.getChildChatroomUrlPostFix + '?'
        baseUrl += 'token' + '=' + sessionStorage.token
        baseUrl += '&' + 'client_id' + '=' + clientId
        window.open(baseUrl, '_blank')
      } else if (action === 'change_disable_ad') {
        this.changeDisableAd(record)
      } 
      // else if(action === 'heartbeat_network_status'){
      //   this.heartbeatNetworkStatus(record)
      // }
    },
    addBot () {
      console.log("all bot list", this.allBotList)
      // console.log('add_bot')
      this.addBotModelVisible = true
    },
    setVip (clientId, vip) {
      axios.post(this.setVipUrl, {
        client_id: clientId,
        vip: vip,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log('修改 VIP 成功')
            const dataSource = [...this.data]
            const target = dataSource.find(item => item.client_id === clientId)
            console.log('target', target)
            if (target) {
              target['vip'] = vip
              console.log('dataSource', dataSource)
              this.data = dataSource
            }
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    resetFreeChatroom (clientId) {
      axios.post(this.resetFreeChatroomUrl, {
        client_id: clientId,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log('重置免费一个群成功')
            const dataSource = [...this.data]
            const target = dataSource.find(item => item.client_id === clientId)
            console.log('target', target)
            if (target) {
              target['probation'] = 1
              console.log('dataSource', dataSource)
              this.data = dataSource
            }
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    editBalance () {

    },
    // jumpTo (record) {
    //   if (record.app === 'zidou') {
    //     localStorage.zidouUserToken = record.token
    //     window.location.href = 'https://www.zidouchat.com/features/analysis/chatroom-list'
    //     console.log('zidou', record.token, localStorage.zidouUserToken)
    //   } else if (record.app === 'yaca') {
    //     localStorage.yacaUserToken = record.token
    //     window.open('https://www.zidouad.com/features/analysis/chatroom-list')
    //     console.log('yaca', record.token, localStorage.yacaUserToken)
    //   } else if (record.app === 'test') {
    //     localStorage.testUserToken = record.token
    //     window.open('https://www.xuanren360.com/features/analysis/chatroom-list')
    //     console.log('test', record.token, localStorage.testUserToken)
    //   }
    // },
    deleteBotConfirm (clientId, botUsername) {
      // console.log('deleteBotConfirm')
      axios.post(this.unbindBotUrl, {
        bot_username: botUsername,
        client_id: clientId,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('删除 Bot 成功')
            const dataSource = [...this.data]
            const target = dataSource.find(item => item.client_id === clientId)
            console.log('target', target)
            if (target) {
              const botList = target['bot_list']
              target['bot_list'] = botList.filter(t => t.username !== botUsername)
              console.log('dataSource', dataSource)
              this.data = dataSource
            }
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    deleteBotCancel () {
      // console.log('deleteBotCancel')
    },
    botSelected (clientId, botSelectedList) {
      console.log('botSelected', clientId, botSelectedList)
      const dataSource = [...this.data]
      const target = dataSource.find(item => item.client_id === clientId)
      // console.log('target', target)
      if (target) {
        botSelectedList.forEach((item) => {
          const allReadyExist = target['bot_list'].find(bot => bot.username === item.username)
          if (!allReadyExist) {
            target['bot_list'].push(item)
          }
        })
        // console.log('dataSource', dataSource)
        this.data = dataSource
      }
    },
    onBalanceEdit (clientId, balance) {
      console.log('onBalanceEdit', clientId, balance)
      const target = this.data.find(item => item.client_id === clientId)
      if (target) {
        target.balance += balance
        // this.data = dataSource
      }
    },
    onFinish (clientId, newCount) {
      // console.log('onFinish', clientId, newCount)
      const target = this.data.find(item => item.client_id === clientId)
      if (target) {
        target.batch_send_max_count = newCount
        // this.data = dataSource
      }
    },
    onFinish1 (clientId, newCount) {
      // console.log('onFinish', clientId, newCount)
      const target = this.data.find(item => item.client_id === clientId)
      if (target) {
        target.batch_everyday_send_max_count = newCount
        // this.data = dataSource
      }
    },
    changeDisableAd (record) {
      this.axios.post(this.changeDisableAdUrl, {
        token: sessionStorage.token,
        client_id: record.client_id
      }).then(res => {
        if (res.data.err_code === 0) {
          this.$message.success('操作成功')
          record.disable_ad === 1 ? record.disable_ad = 0 : record.disable_ad = 1
        } else {
          this.$message.error('操作失败')
        }
      }).catch(err => {
        this.$message.error(`操作失败 ${err}`)
      })
    },
    // heartbeatNetworkStatus(record){
    //   var timestamp = Date.parse(new Date()).toString();
    //   // console.log("record bot list: ", record.bot_list)
    //   console.log("domain: ", this.receiveHeartBeatUrl)
    //   for(var i = 0; i < record.bot_list.length; ++i){
    //     // console.log(record.bot_list[i].username)
    //     // console.log(timestamp)
    //     axios.post(this.receiveHeartBeatUrl, {
    //       wx_id: record.bot_list[i].username,
    //       timestamp: timestamp
    //     }).then(res => {
    //         console.log(res)
    //         if(res.data.err_code === 0){
    //           console.log(res)
    //         }
    //       }
    //     )
    //   }
      
    // },
    getCode () {
      this.axios.post(this.wechatLoginUrl, {
        token: sessionStorage.token
      }).then(res => {
        if (res.data.err_code === 0) {
          this.wechatCode = res.data.content.qrcode_base64
        }
      })
    },
    getSms () {
      this.axios.post(this.getPhoneSmsCodeUrl, {
        token: sessionStorage.token,
        phone: this.failedPhone
      }).then(res => {
        if (res.data.err_code === 0) {
          if (res.data.content.des) {
            this.$message.error(res.data.content.des)
          } else if (res.data.content.code) {
            this.$success({
              title: '验证码',
              content: res.data.content.code,
              onOk () {
              }
            })
          }
        }
      })
    },
    
  }
}
</script>

<style scoped>

</style>
